import React, { useState, useEffect, useMemo } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { useTable, useSortBy } from "react-table";
import { COLUMNS } from "../../../components/table/FilteringTable/Columns";
import { Link } from "react-router-dom";
import { SVGICON } from "../../../constant/theme";
import {
  ActiveInactive_Record,
  delete_Record,
  errorMessage,
  successMessage,
} from "../CommonFunctions";
import {
  POST_EmployeeActiveInActive,
  POST_EmployeeDelete,
  POST_EmployeeExport,
  POST_GetEmployeeList,
  POST_UserResetPasswordUpdate,
} from "../../../helpers/url_helper";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { post } from "../../../helpers/api_helper";
import swal from "sweetalert";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { useFilter } from "../../../../context/FilterContext";

const Employees = () => {
  const [showFilter, setShowFilter] = useState(false);
  const { filter, updateFilter } = useFilter();
  const [isLoading, setIsLoading] = useState(false);

  const [totalNoOfEmployee, setTotalNoOfEmployee] = useState(0);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "employee" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "employee" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);
  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "employee" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "employee" ? filter?.orderBy : "asc"
  );

  const [isReset, setIsReset] = useState(false);

  const [employeeList, setEmployeeList] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const statusOptions = [
    { label: "All", value: -1 },
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ];

  const validationSchema = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      Status: filter && filter?.page == "employee" ? filter?.Status : -1,
      Search: filter && filter?.page == "employee" ? filter?.Search : "",
      // Search: "",
      // Status: -1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: { Search, Status },
  } = formikFilter;

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      Status: -1,
      Search: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "employee",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      Status: Status,
      Search: Search ? Search : "",
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      Status: Status,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };

    await post(POST_GetEmployeeList, payload)
      .then((response) => {
        setTotalNoOfEmployee(response?.TotalNoOfEmployee);
        setRecordCount(response?.TotalRecordCount);
        setEmployeeList(response?.EmployeeList);
        setIsLoading(false);

        if (page > 1 && response?.EmployeeList?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const exportReport = () => {
    setIsLoading(true);

    let payload = {
      Search: Search,
      Status: Status,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };
    post(POST_EmployeeExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [userResetPasswordModal, setUserResetPasswordModal] = useState(false);

  const UserResetPassword = (EmPID, EMPName) => {
    formiksetUserResetPassword.resetForm();
    setUserResetPasswordModal(true);
    formiksetUserResetPassword.setFieldValue("EmployeeIDEncrypt", EmPID);
    formiksetUserResetPassword.setFieldValue("EmployeeName", EMPName);
  };

  const validationSchemaUserResetPassword = Yup.object().shape({
    NewPassword: Yup.string()
      .required("New Password is required field")
      .matches(
        /^(?=.*[A-Z])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Must Contain Minimum 8 Characters, One Capital Letter and One Special Character"
      ),
    //NewPassword: Yup.string().required("New Password is required field"),
    ConfirmPassword: Yup.string()
      .oneOf([Yup.ref("NewPassword"), null], "Passwords must match")
      .required("Confirm Password is a required field."),
  });

  const formiksetUserResetPassword = useFormik({
    validationSchema: validationSchemaUserResetPassword,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitUserResetPassword(values, formikHelpers),
    initialValues: {
      EmployeeIDEncrypt: "",
      NewPassword: "",
      ConfirmPassword: "",
      EmployeeName: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { NewPassword, ConfirmPassword },
  } = formiksetUserResetPassword;

  const handleValidSubmitUserResetPassword = (values) => {
    swal({
      title: "Are you sure you want to Reset Password the record?",
      text: "You won't be able to revert this!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
      //buttons: ["No", "Yes"],
      buttons: {
        cancel: {
          text: "No",
          value: false,
          visible: true,
          className: "btn-sm",
        },
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "btn-sm",
          closeModal: true,
        },
      },
    }).then((willResetPassword) => {
      if (willResetPassword) {
        setIsLoading(true);
        let payload = {
          ...values,
          ModifiedByEncrypt: AuthUser?.LoginIDEncrypt,
        };

        post(POST_UserResetPasswordUpdate, payload)
          .then((response) => {
            if (response?.IsSuccess) {
              successMessage(response?.Message);
              setTimeout(() => {
                formiksetUserResetPassword.resetForm();
                setUserResetPasswordModal(false);
                getData();
              }, 1000);
            } else {
              errorMessage(response?.Message);
              setIsLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
          });
        setIsLoading(false);
      }
    });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Employee</h4>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getResetData();
                  }}
                >
                  <i className="fa fa-window-restore" aria-hidden="true"></i>
                  {"  "}
                  Reset
                </button>
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getData();
                    //setShowFilter(false);
                  }}
                >
                  <i className="fa-solid fa-refresh me-2"></i> Reload
                </button>
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <i className="fa-solid fa-filter me-2"></i>Filter
                </button>
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 9 && x?.IsExport)
                  ?.length > 0 ? (
                  <Link
                    // className="btn btn-primary light btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={exportReport}
                  >
                    <i className="fa-solid fa-file-excel" /> Export Report
                  </Link>
                ) : (
                  ""
                )}
                {(AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 9 && x?.IsAdd)?.length >
                    0) &&
                (AuthUser?.Permissions?.NoOfUser == -1 ||
                  AuthUser?.Permissions?.NoOfUser > totalNoOfEmployee) ? (
                  <Link
                    to="/add-employee"
                    // className="btn btn-primary btn-sm"
                    className="btn btn-outline-primary btn-sm"
                  >
                    <i className="fa-solid fa-plus"></i> Add Employee
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0 pb-0">
              {showFilter ? (
                <div>
                  <FormikProvider value={formikFilter}>
                    <Form onSubmit={formikFilter.handleSubmit}>
                      <Row className="me-0">
                        <Col lg={3}>
                          <Field
                            label="Search"
                            name="Search"
                            placeholder={"Search here..."}
                            component={CustomInput}
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Status"
                            name="Status"
                            placeholder={"Select Status"}
                            options={statusOptions}
                            component={CustomSelect}
                            isClearable={false}
                            menuPosition="fixed"
                          />
                        </Col>
                        <Col lg={3}>
                          <label className="mb-1">&nbsp;</label>
                          <div className="d-flex">
                            <div className="d-lg-block">
                              <Link
                                // className="btn btn-primary btn-sm mb-1"
                                className="btn btn-primary btn-sm"
                                onClick={(e) => {
                                  getData();
                                }}
                              >
                                <i className="fa fa-search" aria-hidden="true"></i>{" "}
                                Search
                              </Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                </div>
              ) : (
                ""
              )}
              <div
                id="Employee-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="Employee-tbl"
                  className="table dataTable display no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th width="6%"></th>
                      <th
                        style={{
                          width: "22%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("EmployeeName");
                        }}
                      >
                        Employee Name{" "}
                        <span className="ml-1">
                          {sortBy == "EmployeeName" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "20%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("EmailID");
                        }}
                      >
                        Email{" "}
                        <span className="ml-1">
                          {sortBy == "EmailID" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "16%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("MobileNo");
                        }}
                      >
                        Mobile No{" "}
                        <span className="ml-1">
                          {sortBy == "MobileNo" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "18%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("DepartmentName");
                        }}
                      >
                        Department{" "}
                        <span className="ml-1">
                          {sortBy == "DepartmentName" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "18%",
                          cursor: "pointer",
                          textAlign: "left",
                        }}
                        onClick={() => {
                          handleClickSorting("DesignationName");
                        }}
                      >
                        Designation
                        <span className="ml-1">
                          {sortBy == "DesignationName" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {employeeList?.length > 0 ? (
                      employeeList?.map((item, indx) => (
                        <tr key={indx}>
                          <td>
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 9 && x?.IsEdit
                            )?.length > 0 ? (
                              <Link
                                to={`/edit-employee/${window.btoa(
                                  item.EmployeeIDEncrypted
                                )}`}
                                className="icon-box icon-box-md me-1"
                                title="Edit"
                              >
                                {SVGICON.EditPrimary}
                              </Link>
                            ) : (
                              ""
                            )}

                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 9 && x?.IsActive
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                // className={`icon-box icon-box-md bg-${
                                //   item.IsActive == true ? "success" : "danger"
                                // }-light me-1`}
                                className={`icon-box icon-box-md me-1`}
                                title={
                                  item.IsActive == true ? "Active" : "Inactive"
                                }
                                onClick={() => {
                                  ActiveInactive_Record(
                                    item.IsActive,
                                    POST_EmployeeActiveInActive,
                                    {
                                      EmployeeIDEncrypted:
                                        item.EmployeeIDEncrypted,
                                      IsActive: !item.IsActive,
                                      ModifiedByEncrypted:
                                        AuthUser?.ReferenceIDEncrypt
                                          ? AuthUser?.ReferenceIDEncrypt
                                          : "0",
                                    },
                                    setIsLoading,
                                    fnCallback,
                                    item.EmployeeName
                                  );
                                }}
                              >
                                <i
                                  className={`fa fa-circle fs-15 ${
                                    item.IsActive == true
                                      ? "text-success"
                                      : "text-danger"
                                  }`}
                                ></i>
                              </Link>
                            ) : (
                              ""
                            )}

                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 9 && x?.IsDelete
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                className="icon-box icon-box-md me-1"
                                title="Delete"
                                onClick={() => {
                                  delete_Record(
                                    POST_EmployeeDelete,
                                    {
                                      EmployeeIDEncrypted:
                                        item.EmployeeIDEncrypted,
                                      ModifiedByEncrypted:
                                        AuthUser?.ReferenceIDEncrypt
                                          ? AuthUser?.ReferenceIDEncrypt
                                          : "0",
                                    },
                                    setIsLoading,
                                    fnCallback,
                                    item.EmployeeName
                                  );
                                }}
                              >
                                {SVGICON.DeleteDanger}
                              </Link>
                            ) : (
                              ""
                            )}

                            {AuthUser?.UserType == 4 ||
                            (AuthUser?.UserType == 1 &&
                              formsList?.filter(
                                (x) => x?.FormID == 9 && (x?.IsEdit || x?.IsAdd)
                              )?.length > 0) ? (
                              <Link
                                to="#"
                                className={`icon-box icon-box-md me-1`}
                                title="Reset Password"
                                onClick={() => {
                                  UserResetPassword(
                                    item.EmployeeIDEncrypted,
                                    item.EmployeeName
                                  );
                                }}
                              >
                                {SVGICON.ResetLock}
                              </Link>
                            ) : (
                              ""
                            )}
                          </td>
                          <td>{item.EmployeeName}</td>
                          <td>{item.EmailID}</td>
                          <td>{item.MobileNo}</td>
                          <td>{item.DepartmentName}</td>
                          <td style={{ textAlign: "left" }}>
                            {item.DesignationName}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="d-sm-flex text-center justify-content-between align-items-center">
                  <CustomSizePerPage
                    getData={getData}
                    currentSizePerPage={currentSizePerPage}
                  />
                  <div className="dataTables_info">
                    Showing{" "}
                    {recordCount > 0
                      ? (currentPage - 1) * currentSizePerPage + 1
                      : 0}{" "}
                    to{" "}
                    {recordCount > currentPage * currentSizePerPage
                      ? currentPage * currentSizePerPage
                      : recordCount}{" "}
                    of {recordCount} entries
                  </div>
                  <CustomPaginationButtons
                    totalPages={recordCount / currentSizePerPage}
                    currentPage={currentPage}
                    currentSizePerPage={currentSizePerPage}
                    getData={getData}
                  />
                </div>
              </div>
            </div>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={userResetPasswordModal}
          onHide={setUserResetPasswordModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formiksetUserResetPassword}>
              <Form onSubmit={formiksetUserResetPassword.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Reset Password</Modal.Title>
                  <button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setUserResetPasswordModal(false)}
                  ></button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        label="Employee Name"
                        name="EmployeeName"
                        placeholder={"Enter Employee Name"}
                        component={CustomInput}
                        disabled={true}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        type="password"
                        label="New Password"
                        name="NewPassword"
                        placeholder={"Enter New Password"}
                        component={CustomInput}
                        required
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        type="password"
                        label="Confirm Password"
                        name="ConfirmPassword"
                        placeholder={"Enter Confirm Password"}
                        component={CustomInput}
                        required
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <button className="btn btn-primary btn-sm me-2" type="submit">
                    <i className="fa-solid fa-floppy-disk"></i> Reset Password
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => setUserResetPasswordModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default Employees;
